/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hwaccel_LinkInputs */

const en_hwaccel_link = /** @type {(inputs: Hwaccel_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to enable hardware acceleration`)
};

const fr_hwaccel_link = /** @type {(inputs: Hwaccel_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment activer l'accélération matérielle`)
};

const ms_sg2_hwaccel_link = /** @type {(inputs: Hwaccel_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara mengaktifkan pecutan perkakasan`)
};

/**
* | output |
* | --- |
* | "How to enable hardware acceleration" |
*
* @param {Hwaccel_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const hwaccel_link = /** @type {((inputs?: Hwaccel_LinkInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hwaccel_LinkInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hwaccel_link(inputs)
	if (locale === "fr") return fr_hwaccel_link(inputs)
	return ms_sg2_hwaccel_link(inputs)
});